import { useEffect, useState } from "react"

// import { isBrowser } from './misc/util';

// from https://github.com/streamich/react-use/blob/master/src/useMedia.ts
const useMedia = (query: string, defaultState: boolean = false) => {
  // NOTE: ssrとモバイル時にstateの値が変わって、レンダリングに差が出てバグる
  // const [state, setState] = useState(isBrowser ? () => window.matchMedia(query).matches : defaultState)
  const [state, setState] = useState(defaultState)

  useEffect(() => {
    let mounted = true
    const mql = window.matchMedia(query)
    const onChange = (e: MediaQueryListEvent) => {
      if (!mounted) {
        return
      }
      setState(e.matches)
    }
    // NOTE:addListenerは非推奨だが、addEventListenerに対応していないブラウザが多数あるためやむをえず
    mql.addListener(onChange)
    // mql.addEventListener("change", onChange)

    setState(mql.matches)

    return () => {
      mounted = false
      mql.removeListener(onChange)
      // mql.removeEventListener("change", onChange)
    }
  }, [query])

  return state
}

// TODO: checkMobile を↓に置き換える
export const useMobileMedia = (defaultState: boolean = false) => useMedia("(max-width: 768px)", defaultState)
